import { create } from "zustand";

interface StoreState {
  uid: string;
  setAuth: (uid: string) => void;
}

export const useAuthStore = create<StoreState>((set) => ({
  uid: null,
  setAuth: (uid: string) => set(() => ({ uid }))
}));
